export default {
  title: 'Cancel registration',
  body: 'Free up your spot for someone else and get a refund, if eligible.',
  reservationLookup: {
    title: 'Let’s find your registration',
    popover: {
      name: 'Where to find your Reservation Number',
      body: 'Your Reservation Number is in your email confirmation. Subject line: “REI Experiences: Your Registration Has Been Confirmed”',
    },
    button: 'Find my registration',
    error:
      'Hmm, no registrations match those details. Please double check the info below and try again. Need help? Email your registration and contact info to <a href="mailto:experiences@rei.com" data-analytics-id="day-cancellation:ReservationLookup_contact information" target="_blank">experiences@rei.com</a>.',
  },
  selectReservations: {
    title: 'Select participants',
    registrationHeading: 'Your registration',
    spotCancelHeading: 'Whose spot would you like to cancel?',
    paymentMessage: {
      refund:
        'If this is a paid class, a full refund will be issued to the original payment method.',
    },
    navigation: {
      primary: 'Continue',
      secondary: 'Back',
      link: {
        href: 'https://www.rei.com/events',
        name: 'I don’t want to cancel',
      },
    },
  },
  confirmCancellation: {
    title: 'Confirm cancellation',
    cancelHeading: 'You are cancelling',
    navigation: {
      primary: 'Confirm cancellation',
      secondary: 'Back',
      link: {
        href: 'https://www.rei.com/events',
        name: 'I don’t want to cancel',
      },
    },
  },
  cancelledReservation: {
    title: 'Cancel registration',
    subTitle: 'This registration has already been canceled',
    cancelHeading: 'Canceled registration',
    navigation: {
      primary: 'Back to Classes & Events Home',
      secondary: 'Back',
    },
  },
  cancellationSuccess: {
    title: 'Registration canceled—you’ll be missed!',
    subTitle: 'Thanks for letting us know you couldn’t make it. ',
    body: 'You should see an email confirmation soon—it may take up to 15 minutes. Eligible refunds will be processed within 3 business days.',
    link: {
      href: 'https://www.rei.com/events',
      name: 'Back to Classes & Events',
    },
  },
  cancellationError: {
    title: 'Cancel registration',
    subTitle: 'Hmm. Something went wrong.',
    body: 'Please try again later or <a href="https://www.rei.com/events/resources/contact" data-analytics-id="day-cancellation:CancellationError_contact information">give us a call</a>',
  },
  policy: {
    title: 'Cancellation & Refund policy',
    body: 'To receive a full refund, reservations must be canceled during the eligible cancellation period. <a href="https://www.rei.com/events/resources/cancellation" data-analytics-id="day-cancellation:RefundPolicy_refund policy" target="_blank" title="See full cancellation & refund policy">See full cancellation & refund policy</a>',
  },
  disabled: {
    title: 'Hmm. Something went wrong.',
    body: 'Please call <a href="tel:1-800-622-2236" data-analytics-id="day-cancellation:CancellationDisabled_phone number">1 (800) 622-2236</a> to cancel your reservation.',
  },
};
